window.addEventListener('DOMContentLoaded', () => {
    
    //Add observer
    const elemToObserve = document.querySelector('body');
    let prevClassState = elemToObserve.classList.contains('large-font');
    const observer = new MutationObserver( (mutations) => {
        mutations.forEach(function(mutation) {
            if(mutation.attributeName == "class"){
                const currentClassState = mutation.target.classList.contains('large-font');
                if(prevClassState !== currentClassState)    {
                    prevClassState = currentClassState;
                    if(currentClassState)
                        setFontSize('large')
                    else
                        setFontSize('small')
                }
            }
        });
    });
    observer.observe(elemToObserve, {attributes: true});

    const setFontSize = (fontsize) => {
        
        const allElements = document.querySelectorAll('.container *');

        if( 'large' === fontsize ) {

            allElements.forEach(el => {
            const styles = window.getComputedStyle(el);
                
                if ( parseInt(styles.fontSize) <= 16 ) {
                    el.dataset.originalFontSize = parseInt(styles.fontSize);
                    el.style.fontSize =  `${parseInt(styles.fontSize)*1.2}px`;
                }
            })

        } else if( 'small' === fontsize ) {

            allElements.forEach(el => {
                el.style.fontSize = `${el.dataset.originalFontSize}px`;
            });
        }

    }

    if( document.body.classList.contains('large-font')) {
        setFontSize('large');
    }

});
